<template>
  <v-card class="news-card" elevation="2">
    <v-card-title>{{ news.title }}</v-card-title>
    <v-card-text>
      <div class="news-text" v-html="news.descr" @click="handleLink"></div>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <a v-if="news.navTo" link @click="handleLink" :href="news.navTo">
        continua a leggere
      </a>
      <v-btn
        v-if="showRead"
        color="primary"
        outlined
        @click.stop.prevent="$emit('read')"
      >
        Ok
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss">
.news-card {
  .news {
    height: 170px;
    cursor: pointer;
  }
  .news-text {
    flex: 1;
    display: -webkit-box;
    height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
<script>
export default {
  name: "NewsCard",
  props: {
    news: { type: Object, required: true },
    showOpened: { type: Boolean, default: true },
    showRead: { type: Boolean, default: false }
  },
  methods: {
    handleLink() {
      this.$emit("read");
      if (!this.news.navTo) return;
      let link = new URL(this.news.navTo, window.location.href);
      //utilizzare stessa tecnica della page per capire se è un link interno o no....
      if (global.config.domainWhitelist.includes(link.hostname)) {
        let resolved = this.$router.resolve({
          path: link.pathname
        });
        if (
          resolved &&
          resolved.route.matched.length > 0 &&
          resolved.route.name != "DefaultRoute"
        ) {
          this.$router.push(resolved.route);
        } else {
          openExternal(link);
        }
      } else {
        openExternal(link);
      }
      function openExternal(link) {
        if (this.isCordova && link.indexOf("http") > -1) {
          //if app open on _system browser
          window.cordova.InAppBrowser.open(link.href, "_system");
        } else {
          window.open(link, "blank");
        }
      }
    }
  }
};
</script>
